export default __webpack_public_path__ + "static/media/noun_Download_1560897.8c2b5993.svg";